module.exports = __webpack_public_path__ + "img/biao1.5ad0bc10.webp";